import { get, post, put, destroy } from "./base";

const DeliveryStaffServ = {
    index: (params) => get("/delivery-staff", { params }),
    create: (payload) => post("/delivery-staff", payload),
    update: (id, payload) => put(`/delivery-staff/${id}`, payload),
    remove: (id) => destroy(`/delivery-staff/${id}`),
    uploadImage: (formData) => post("/upload/image", formData),
};

export default DeliveryStaffServ;
